<template>
  <div v-if="icon" class="smile-icon" :class="icon.color">
    <svg xmlns="http://www.w3.org/2000/svg" :class="sizeClass" viewBox="0 0 256 256">
      <path fill="currentColor" :d="icon.path" />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    score: number;
    size?: 'sm' | 'md';
  }>(),
  { size: 'md' }
);

const sizeClass = computed(() => (props.size === 'sm' ? 'h-6 w-6' : 'h-8 w-8'));

const SAD_PATH =
  'M128 26a102 102 0 1 0 102 102A102.12 102.12 0 0 0 128 26m0 192a90 90 0 1 1 90-90a90.1 90.1 0 0 1-90 90M82 108a10 10 0 1 1 10 10a10 10 0 0 1-10-10m92 0a10 10 0 1 1-10-10a10 10 0 0 1 10 10m-.81 65a6 6 0 0 1-10.38 6c-7.84-13.54-20.2-21-34.81-21s-27 7.46-34.81 21a6 6 0 0 1-5.2 3a5.9 5.9 0 0 1-3-.81a6 6 0 0 1-2.18-8.19c9.92-17.16 26.39-27 45.19-27s35.27 9.84 45.19 27';
const NEUTRAL_PATH =
  'M128 26a102 102 0 1 0 102 102A102.12 102.12 0 0 0 128 26m0 192a90 90 0 1 1 90-90a90.1 90.1 0 0 1-90 90m46-58a6 6 0 0 1-6 6H88a6 6 0 0 1 0-12h80a6 6 0 0 1 6 6m-92-52a10 10 0 1 1 10 10a10 10 0 0 1-10-10m92 0a10 10 0 1 1-10-10a10 10 0 0 1 10 10';
const HAPPY_PATH =
  'M173.19 155c-9.92 17.16-26.39 27-45.19 27s-35.27-9.84-45.19-27a6 6 0 0 1 10.38-6c7.84 13.54 20.2 21 34.81 21s27-7.46 34.81-21a6 6 0 1 1 10.38 6M230 128A102 102 0 1 1 128 26a102.12 102.12 0 0 1 102 102m-12 0a90 90 0 1 0-90 90a90.1 90.1 0 0 0 90-90M92 118a10 10 0 1 0-10-10a10 10 0 0 0 10 10m72-20a10 10 0 1 0 10 10a10 10 0 0 0-10-10';

const SCORE_MAP: Record<number, { color: string; path: string }> = {
  1: { color: 'text-red-600', path: SAD_PATH },
  2: { color: 'text-red-300', path: NEUTRAL_PATH },
  3: { color: 'text-yellow-400', path: NEUTRAL_PATH },
  4: { color: 'text-green-300', path: NEUTRAL_PATH },
  5: { color: 'text-green-600', path: HAPPY_PATH },
};

const icon = computed(() => SCORE_MAP[props.score]);
</script>

<style scoped>
@reference "tailwindcss";

.smile-icon {
  @apply block flex items-center justify-center;
}
</style>
